export const isString = (x: unknown): x is string => typeof x === 'string'

export const stripSpaces = (alphaNumeric: string) => alphaNumeric.replace(/\D/g, '')
